import { render, staticRenderFns } from "./CategoryAdd.vue?vue&type=template&id=af8acd7e"
import script from "./CategoryAdd.vue?vue&type=script&lang=js"
export * from "./CategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports